/* Satin Curl v3 — scènes cinématiques, profondeur, comparateur, défilement horizontal.
Complète satin-curl.js (v2). Vanilla JS, sans dépendance. */
(function () {
'use strict';
if (window.__satinCurlV3) return;
window.__satinCurlV3 = true;
var root = document.documentElement;
var reduceMQ = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
var fineMQ = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
var deskMQ = window.matchMedia ? matchMedia('(min-width: 900px)') : { matches: true };
function reduced() { return reduceMQ.matches || root.classList.contains('sc-no-motion'); }
function $(s, c) { return (c || document).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
var raf = window.requestAnimationFrame.bind(window);
var money = (function () {
var f; try { f = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); } catch (e) {}
return function (c) { var v = (c || 0) / 100; return f ? f.format(v) : v.toFixed(2).replace('.', ',') + ' €'; };
})();
function initIntro() {
var intro = $('.v3-intro');
if (!intro) return;
var bg = intro.getAttribute('data-bg');
var satin = $('.v3-intro__satin', intro);
if (bg && satin) satin.style.backgroundImage = 'url("' + bg + '")';
function skip() { root.classList.add('sc-intro-skip'); }
intro.addEventListener('click', skip);
document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { skip(); document.removeEventListener('keydown', k); } });
setTimeout(function () { intro.remove(); }, 3200);
}
function splitLetters() {
$$('[data-sc-letters]:not([data-letters-done])').forEach(function (el) {
el.setAttribute('data-letters-done', '');
var cl = el.cloneNode(true); $$('br', cl).forEach(function (b) { b.replaceWith(' '); });
el.setAttribute('aria-label', cl.textContent.replace(/\s+/g, ' ').trim());
var i = 0;
(function walk(node) {
Array.prototype.slice.call(node.childNodes).forEach(function (n) {
if (n.nodeType === 3) {
var frag = document.createDocumentFragment();
n.nodeValue.split(/(\s+)/).forEach(function (word) {
if (!word) return;
if (/^\s+$/.test(word)) { frag.appendChild(document.createTextNode(' ')); return; }
var w = document.createElement('span'); w.style.whiteSpace = 'nowrap'; w.style.display = 'inline-block';
Array.prototype.forEach.call(word, function (ch) {
var o = document.createElement('span'); o.className = 'v3-l';
var s = document.createElement('span'); s.textContent = ch; s.style.setProperty('--i', i++);
o.appendChild(s); w.appendChild(o);
});
frag.appendChild(w);
});
node.replaceChild(frag, n);
} else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
});
})(el);
});
}
var scrollItems = [], hItems = [], ticking = false, lastY = window.scrollY, vel = 0;
function measureH() {
hItems.forEach(function (h) {
if (!deskMQ.matches || reduced()) { h.el.style.height = ''; h.dist = 0; return; }
h.dist = Math.max(0, h.track.scrollWidth - window.innerWidth);
h.el.style.height = (h.dist + window.innerHeight) + 'px';
});
}
function onScroll() { if (!ticking) { ticking = true; raf(update); } }
function update() {
ticking = false;
var vh = window.innerHeight, y = window.scrollY;
vel = vel * 0.8 + (y - lastY) * 0.2; lastY = y;
if (reduced()) return;
scrollItems.forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.bottom < -vh * 0.5 || r.top > vh * 1.5) return;
var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
el.style.setProperty('--p', p.toFixed(4));
});
hItems.forEach(function (h) {
if (!h.dist) return;
var r = h.el.getBoundingClientRect();
var prog = clamp(-r.top / h.dist, 0, 1);
h.track.style.setProperty('--hx', (-prog * h.dist).toFixed(1) + 'px');
h.el.style.setProperty('--hp', prog.toFixed(4));
h.cards.forEach(function (c) {
var cr = c.getBoundingClientRect();
var mid = (cr.left + cr.width / 2) / window.innerWidth;
c.style.setProperty('--cv', clamp(1 - Math.abs(mid - 0.5) * 1.6, 0, 1).toFixed(3));
});
});
$$('[data-sc-marquee]').forEach(function (m) { m.style.setProperty('--skew', clamp(-vel * 0.12, -8, 8).toFixed(2) + 'deg'); });
if (Math.abs(vel) > 0.3) onScroll();
}
function initScroll() {
scrollItems = $$('[data-sc-scroll]');
hItems = $$('[data-sc-hscroll]').map(function (el) { var t = $('[data-sc-htrack]', el); return { el: el, track: t, cards: $$('.v3-anat__card', t), dist: 0 }; }).filter(function (h) { return h.track; });
measureH();
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', function () { measureH(); onScroll(); });
window.addEventListener('load', function () { measureH(); onScroll(); });
if (deskMQ.addEventListener) deskMQ.addEventListener('change', function () { measureH(); onScroll(); });
update();
}
function initDepth() {
$$('[data-sc-depth]').forEach(function (stage) {
$$('[data-depth]', stage).forEach(function (el) { el.style.setProperty('--k', el.getAttribute('data-depth')); });
if (!fineMQ.matches) return;
var host = stage.closest('section') || stage;
host.addEventListener('pointermove', function (e) {
if (reduced()) return;
stage.style.setProperty('--mx', (e.clientX / window.innerWidth - 0.5) * 2);
stage.style.setProperty('--my', (e.clientY / window.innerHeight - 0.5) * 2);
}, { passive: true });
host.addEventListener('pointerleave', function () { stage.style.setProperty('--mx', 0); stage.style.setProperty('--my', 0); });
});
}
function initSwitchers() {
var groups = {};
$$('[data-sc-switch-stage]').forEach(function (st) { groups[st.getAttribute('data-sc-switch-stage')] = { stage: st, items: $$('.v3-switch__item', st), idx: 0, touched: false, timer: 0, visible: false }; });
Object.keys(groups).forEach(function (name) {
var g = groups[name];
var btns = $$('[data-sc-switch="' + name + '"]');
function go(i, from) {
if (i === g.idx || !g.items[i]) return;
var sr = g.stage.getBoundingClientRect();
var ox = 50, oy = 50;
if (from) { var br = from.getBoundingClientRect(); ox = clamp((br.left + br.width / 2 - sr.left) / sr.width * 100, -20, 120); oy = clamp((br.top + br.height / 2 - sr.top) / sr.height * 100, -20, 120); }
g.items.forEach(function (it, k) { it.classList.toggle('is-prev', k === g.idx); it.classList.remove('is-active'); });
var next = g.items[i];
next.style.setProperty('--ox', ox + '%'); next.style.setProperty('--oy', oy + '%');
void next.offsetWidth;
next.classList.add('is-active');
g.idx = i;
btns.forEach(function (b) { var on = parseInt(b.getAttribute('data-index'), 10) === i; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
var label = btns[i] && btns[i].getAttribute('data-label');
$$('[data-sc-switch-label="' + name + '"]').forEach(function (l) { l.textContent = label || ''; });
$$('[data-sc-switch-num="' + name + '"]').forEach(function (l) { l.textContent = (i < 9 ? '0' : '') + (i + 1); });
$$('[data-sc-switch-link="' + name + '"]').forEach(function (a) {
var ids = (a.getAttribute('data-variants') || '').split(',');
if (ids[i]) a.href = a.getAttribute('data-base') + '?variant=' + ids[i];
});
}
btns.forEach(function (b) {
b.addEventListener('click', function () { g.touched = true; go(parseInt(b.getAttribute('data-index'), 10), b); });
});
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (en) { g.visible = en[0].isIntersecting; }, { threshold: 0.35 }).observe(g.stage);
}
g.timer = setInterval(function () {
if (g.touched || !g.visible || reduced() || document.hidden || g.items.length < 2) return;
go((g.idx + 1) % g.items.length, btns[(g.idx + 1) % g.items.length]);
}, name === 'hero' ? 5200 : 4200);
});
}
function initCompare() {
$$('[data-sc-compare]').forEach(function (box) {
var range = $('input[type=range]', box);
function set(v) { box.style.setProperty('--pos', clamp(v, 0, 100) + '%'); if (range) range.value = clamp(v, 0, 100); }
if (range) range.addEventListener('input', function () { box.dataset.touched = '1'; set(parseFloat(range.value)); });
box.addEventListener('pointerdown', function () { box.classList.add('is-drag'); });
window.addEventListener('pointerup', function () { box.classList.remove('is-drag'); });
if (!('IntersectionObserver' in window)) return;
var io = new IntersectionObserver(function (en) {
if (!en[0].isIntersecting || reduced()) return;
io.disconnect();
var t0 = performance.now();
(function hint(t) {
if (box.dataset.touched) return;
var k = (t - t0) / 2200;
if (k >= 1) { set(50); return; }
set(50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k * 0.6));
raf(hint);
})(t0);
}, { threshold: 0.5 });
io.observe(box);
});
}
function initCounts() {
var els = $$('[data-sc-count]');
if (!els.length || !('IntersectionObserver' in window)) return;
var io = new IntersectionObserver(function (en) {
en.forEach(function (e) {
if (!e.isIntersecting) return;
io.unobserve(e.target);
if (reduced()) return;
var el = e.target, to = parseInt(el.getAttribute('data-sc-count'), 10), from = Math.round(to * 0.55), t0 = performance.now(), d = 1300;
(function step(t) {
var k = clamp((t - t0) / d, 0, 1); k = 1 - Math.pow(1 - k, 4);
el.textContent = money(Math.round(from + (to - from) * k));
if (k < 1) raf(step);
})(t0);
});
}, { threshold: 0.6 });
els.forEach(function (el) { io.observe(el); });
}
function initCursor() {
if (!fineMQ.matches || reduced()) return;
var c = document.createElement('div'); c.className = 'v3-cursor'; c.setAttribute('aria-hidden', 'true');
var label = document.createElement('span'); c.appendChild(label);
document.body.appendChild(c);
var x = 0, y = 0, cx = 0, cy = 0, run = false;
function loop() { cx += (x - cx) * 0.2; cy += (y - cy) * 0.2; c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)'; if (Math.abs(x - cx) + Math.abs(y - cy) > 0.3) raf(loop); else run = false; }
document.addEventListener('pointermove', function (e) {
if (e.pointerType !== 'mouse' || reduced()) { c.classList.remove('is-on'); return; }
x = e.clientX; y = e.clientY; c.classList.add('is-on');
var t = e.target;
var big = t.closest && t.closest('.v3-switch, .sc-stage, .v3-anat__img, .v3-expand__photo, .v3-pdp-macro__item, .sc-color2__card');
var link = !big && t.closest && t.closest('a, button, input[type=range], summary, label');
c.classList.toggle('is-big', !!big);
c.classList.toggle('is-link', !!link);
label.textContent = big ? (t.closest('.sc-stage') ? 'Zoom' : (t.closest('[data-sc-compare]') ? '' : 'Voir')) : '';
if (!run) { run = true; raf(loop); }
}, { passive: true });
document.addEventListener('pointerleave', function () { c.classList.remove('is-on'); });
$$('[data-sc-compare]').forEach(function (b) { b.addEventListener('pointerenter', function () { c.classList.add('is-big'); label.textContent = '⟷'; }); });
}
function burst(el) {
if (reduced() || !el) return;
var r = el.getBoundingClientRect();
var b = document.createElement('div'); b.className = 'v3-burst';
b.style.left = (r.left + r.width / 2) + 'px'; b.style.top = (r.top + r.height / 2) + 'px';
for (var i = 0; i < 22; i++) {
var p = document.createElement('i');
var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 120;
p.style.setProperty('--x', (Math.cos(a) * d).toFixed(0) + 'px');
p.style.setProperty('--y', (Math.sin(a) * d * 0.7 - 30).toFixed(0) + 'px');
p.style.setProperty('--s', (4 + Math.random() * 7).toFixed(1) + 'px');
p.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
b.appendChild(p);
}
document.body.appendChild(b);
setTimeout(function () { b.remove(); }, 1300);
}
function initAtcFeedback() {
$$('[data-sc-atc]').forEach(function (btn) {
var mo = new MutationObserver(function () { if (btn.classList.contains('is-done') && !btn._v3) { btn._v3 = 1; burst(btn); setTimeout(function () { btn._v3 = 0; }, 1500); } });
mo.observe(btn, { attributes: true, attributeFilter: ['class'] });
});
}
function initGalleryDirection() {
var stage = $('[data-sc-stage]');
if (!stage) return;
var slides = $$('[data-sc-slide]', stage);
var mo = new MutationObserver(function (list) {
list.forEach(function (m) {
var s = m.target;
if (s.classList.contains('is-active') && m.oldValue && m.oldValue.indexOf('is-active') === -1) {
var prev = slides.filter(function (x) { return x.classList.contains('is-prev'); })[0];
var back = prev && slides.indexOf(s) < slides.indexOf(prev);
s.style.clipPath = back ? 'inset(0 100% 0 0)' : 'inset(0 0 0 100%)';
s.style.transition = 'none'; void s.offsetWidth;
s.style.transition = ''; s.style.clipPath = '';
}
});
});
slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }); });
}
function initBokeh() {
if (reduced()) return;
var cv = document.createElement('canvas'), ctx = cv.getContext('2d');
cv.className = 'sc-snow v3-bokeh'; cv.setAttribute('aria-hidden', 'true');
cv.style.zIndex = '41'; cv.style.filter = 'blur(1.5px)';
document.body.appendChild(cv);
var w, h, dpr, flakes = [], gust = 0, nextGust = 0, mx = 0, id = 0, sy = window.scrollY, vy = 0;
var spr = (function () {
var c = document.createElement('canvas'), s = 96; c.width = c.height = s;
var g = c.getContext('2d'), gr = g.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
gr.addColorStop(0, 'rgba(255,252,246,.95)'); gr.addColorStop(.4, 'rgba(243,230,204,.5)'); gr.addColorStop(1, 'rgba(243,230,204,0)');
g.fillStyle = gr; g.fillRect(0, 0, s, s); return c;
})();
function mk(any) { return { x: Math.random() * w, y: any ? Math.random() * h : -60, r: 14 + Math.random() * 22, v: 0.9 + Math.random() * 0.9, a: 0.08 + Math.random() * 0.14, d: Math.random() * 6.28 }; }
function size() {
dpr = Math.min(window.devicePixelRatio || 1, 2); w = innerWidth; h = innerHeight;
cv.width = w * dpr; cv.height = h * dpr; cv.style.width = w + 'px'; cv.style.height = h + 'px';
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
var n = fineMQ.matches ? 16 : 8; flakes = []; for (var i = 0; i < n; i++) flakes.push(mk(true));
}
function tick(t) {
ctx.clearRect(0, 0, w, h);
if (t > nextGust) { gust = (Math.random() - 0.3) * 3; nextGust = t + 6000 + Math.random() * 8000; }
gust *= 0.994;
var y = window.scrollY; vy = vy * 0.85 + (y - sy) * 0.15; sy = y;
for (var i = 0; i < flakes.length; i++) {
var f = flakes[i];
f.d += 0.01; f.y += f.v - clamp(vy, -40, 40) * 0.12; f.x += Math.sin(f.d) * 0.6 + gust + mx * 0.8;
if (f.y > h + 60 || f.y < -80 || f.x < -80 || f.x > w + 80) { flakes[i] = mk(false); if (vy > 2) flakes[i].y = h + 50; continue; }
ctx.globalAlpha = f.a; ctx.drawImage(spr, f.x - f.r * 2, f.y - f.r * 2, f.r * 4, f.r * 4);
}
ctx.globalAlpha = 1;
id = raf(tick);
}
size();
window.addEventListener('resize', size);
document.addEventListener('pointermove', function (e) { mx = (e.clientX / (w || 1) - 0.5); }, { passive: true });
document.addEventListener('visibilitychange', function () { if (document.hidden) cancelAnimationFrame(id); else id = raf(tick); });
var start = function () { id = raf(tick); };
setTimeout(start, root.classList.contains('sc-intro-on') ? 2400 : 400);
function sync() { if (reduced()) { cancelAnimationFrame(id); cv.hidden = true; } else if (cv.hidden) { cv.hidden = false; id = raf(tick); } }
document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-sc-motion-toggle]')) setTimeout(sync, 0); });
if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', sync);
}
function init() {
initBokeh();
initIntro();
splitLetters();
initScroll();
initDepth();
initSwitchers();
initCompare();
initCounts();
initCursor();
initAtcFeedback();
initGalleryDirection();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();